// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__2utnl","expandIcon":"AccordionButton_expandIcon__2kfbL","expanded":"AccordionButton_expanded__2t56M"};